var _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFastgamesapi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 80,
    viewBox: "0 0 320 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 8 L18 44 H30 L26 72 L48 32 H34 L42 8 Z",
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 53,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    fill: "white",
    letterSpacing: 0.5
  }, "FastGames", /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 400
  }, "API"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastgamesapi);
export default __webpack_public_path__ + "static/media/fastgamesapi.1937e21aee262e6887f23b450bb31f92.svg";
export { ForwardRef as ReactComponent };